/*
 * @Author: songyzh
 * @Date: 2020-08-19 10:30:51
 * @LastEditors: songyzh
 * @LastEditTime: 2020-08-21 11:28:28
 */
import { POST, GET, DELETE } from './base';

export function signup(userInfo) {
  return POST('/auth/signup', '用户注册', userInfo);
}

export function signin(userInfo) {
  return POST('/auth/signin', '用户登录', userInfo);
}

export function getAllUsers() {
  return GET('/auth/users', '获取所有用户');
}

export function deleteUser(id) {
  return DELETE(`/auth/${id}`, '删除用户');
}

export function updateUserPwd(id, password) {
  return POST(`/auth/update/${id}/${password}`, '修改密码');
}
